import { h } from 'preact';

const ButtonIcon = ({ children, className }) => (
  <span class={`relative w-8 h-8 rounded-full mr-2.5 -ml-4 inline-flex items-center justify-center ${className}`}>
    <span class="absolute inset-0 rounded-full bg-gradient-to-br from-black to-white opacity-15 group-hover:opacity-25 transition-opacity" style={{ filter: 'blur(1px)' }} />
    {children}
  </span>
);

function Button({ as, className, children, ...props }) {
  return h(
    as,
    {
      className: `bg-purple-600 text-white hover:bg-purple-800 font-medium py-2 px-6 rounded-full flex items-center group transition-colors text-shadow focus:outline-none focus:ring ring-purple-400 ${className}`,
      ...props,
    },
    children,
  );
}

Button.defaultProps = {
  as: 'button',
  className: '',
};

export { Button as default, ButtonIcon };
